import "core-js/modules/es.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.reverse.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*----------------------------------------------------*/
// Dependencies

/*----------------------------------------------------*/
import gsap from 'gsap';
import Controller from '../core/controller';
/*----------------------------------------------------*/
// Constants & variables

/*----------------------------------------------------*/

var instance;
var defaults = {
  name: 'navigation',
  $: {
    header: '.app-header',
    mobile: '.app-responsive-header',
    pan: '.made-by-pan',
    logo: '.logo__media',
    nav: '.header__navigation .root-parent li',
    respNav: '.responsive__primary',
    btnOpen: '*[data-action="open-nav"]',
    btnClose: '*[data-action="close-nav"]',
    dropdown: '*[data-toggle="dropdown"]',
    accordion: '*[data-toggle="accordion"]',
    searchBar: '.strasbourg-banner__search',
    searchOpen: '*[data-action="open-search"]',
    searchClose: '*[data-action="close-search"]',
    searchInput: '.strasbourg-banner__search input'
  },
  $$: {
    dropdown: '*[data-toggle="dropdown"]'
  }
};
var properties = {
  tl: {},
  opened: false,
  initialized: false,
  scrolled: 0,
  enabled: [],
  animations: []
};
/*----------------------------------------------------*/
// Module

/*----------------------------------------------------*/

var Navigation = /*#__PURE__*/function (_Controller) {
  _inherits(Navigation, _Controller);

  var _super = _createSuper(Navigation);

  function Navigation(element, controller) {
    var _this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Navigation);

    // singleton
    if (instance) {
      return _possibleConstructorReturn(_this, instance);
    } // options


    var opts = Object.assign(defaults, options);
    _this = _super.call(this, element, controller, opts); // properties

    Object.assign(_assertThisInitialized(_this), Controller.cloneDeep(properties));
    _this.$element = $d(document.body);
    instance = _assertThisInitialized(_this);
    return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
  } // Lifecycles
  // --------------------------------------------------


  _createClass(Navigation, [{
    key: "created",
    value: function created() {
      if (!this.initialized) {
        _get(_getPrototypeOf(Navigation.prototype), "created", this).call(this);

        this.madeByPan();
        this.attach();
        this.bindEvents();
        this.initialized = true;
      }
    } // Navigation
    // --------------------------------------------------

  }, {
    key: "open",
    value: function open() {
      var _this2 = this;

      if (this.opened) return;
      this.opened = true;
      this.app.$html.addClass('nav-opened');
      var $item = this.$.respNav.find('.root-parent li');
      var tl = gsap.timeline({
        paused: true,
        onComplete: function onComplete() {
          var $clearElms = [_this2.$.btnClose[0], $item].filter(function (el) {
            return el.length;
          });
          gsap.set($clearElms, {
            clearProps: 'all'
          });
        }
      });
      tl.fromTo(this.$.btnClose[0], {
        autoAlpha: 0,
        rotation: 180
      }, {
        autoAlpha: 1,
        rotation: 0,
        duration: 2,
        ease: 'power4.out'
      });
      tl.fromTo($item, {
        autoAlpha: 0,
        x: -40
      }, {
        autoAlpha: 1,
        x: 0,
        duration: 0.4,
        stagger: 0.15,
        ease: 'power2.out'
      }, '-=1.8');
      tl.play(); // defer event application

      window.setTimeout(function () {
        _this2.app.$html.on('click', _this2.bounds.outside);
      }, 0);
    }
  }, {
    key: "close",
    value: function close() {
      var _this3 = this;

      if (!this.opened) return;
      this.app.$html.removeClass('nav-opened');
      window.setTimeout(function () {
        _this3.app.$html.off('click', _this3.bounds.outside);

        _this3.opened = false;
      }, 0);
    } // Navbar
    // --------------------------------------------------

  }, {
    key: "stickyNavBar",
    value: function stickyNavBar() {
      var scroll = this.scroll;

      if (scroll > this.scrolled && scroll > 150) {
        this.app.$html.addClass('navbar--scrolled');
      } else {
        this.app.$html.removeClass('navbar--scrolled');
      }

      this.scrolled = scroll;
    } // Pan sprite
    // --------------------------------------------------

  }, {
    key: "madeByPan",
    value: function madeByPan() {
      var $sprite = this.$.pan.find('.logo-pan');
      var spriteR = 1.5;
      var spriteW = 6320 / spriteR;
      var frameW = 80 / spriteR;
      var totalFrames = spriteW / frameW; // timeline

      var tl = gsap.timeline({
        paused: true
      });
      tl.fromTo($sprite, {
        x: 0
      }, {
        x: -spriteW + frameW,
        duration: 2,
        ease: "steps(".concat(totalFrames - 1, ")")
      });
      tl.set({}, {}, 1);
      this.tl.pan = tl;
    }
  }, {
    key: "attach",
    value: function attach() {
      var _this4 = this;

      this.$.dropdown.each(function (i, elm) {
        if (_this4.enabled.indexOf(elm) < 0) {
          _this4.attachDropdown(elm);
        }
      });
    } // Search
    // --------------------------------------------------

  }, {
    key: "searchOpen",
    value: function searchOpen() {
      this.$.searchBar.addClass('open');
    }
  }, {
    key: "searchClose",
    value: function searchClose() {
      this.$.searchBar.removeClass('open');
    } // Dropdowns
    // --------------------------------------------------

  }, {
    key: "attachDropdown",
    value: function attachDropdown(elm) {
      var $elm = $d(elm);
      var app = this.app;

      function hide(dropdown) {
        var $dropdown = $d(dropdown);
        $dropdown.removeClass('is-open');
        app.$body.off('click.dropdown');
      }

      function show(dropdown) {
        var $dropdown = $d(dropdown);
        $dropdown.addClass('is-open'); // close if we click outside

        setTimeout(function () {
          app.$body.on('click.dropdown', function (e) {
            var target = e.target;

            if (target !== $dropdown[0] && !$dropdown[0].contains(target)) {
              if (e) e.preventDefault();
              hide(dropdown);
            }
          });
        }, 0);
      }

      function onClick() {
        var $this = $d(this);
        var $group = $this.closest('.dropdown');
        var opened = $group.hasClass('is-open');

        if (opened) {
          hide($group);
        } else {
          show($group);
        }
      }

      $elm.on('click.fields', onClick);
      this.enabled.push(elm);
    } // Accordion
    // --------------------------------------------------

  }, {
    key: "accordionInit",
    value: function accordionInit() {
      var _this5 = this;

      this.$.accordion.each(function (index, el) {
        var tl = gsap.timeline();
        var accContent = el.querySelector('.accordion__content');
        var chevron = el.querySelector('.icon-chevron_right');
        var animation = tl.to(accContent, {
          height: 'auto',
          duration: 0.5,
          ease: 'power1.inOut',
          reversed: false
        }).to(chevron, {
          reversed: false,
          rotate: 90,
          ease: 'power3.out',
          duration: 0.25
        }, '<');
        el.animation = animation;

        _this5.animations.push(animation);
      });
    }
  }, {
    key: "toggleAccordion",
    value: function toggleAccordion(e) {
      if (this.animations.length !== 0) {
        var selectedReversedState = e.currentTarget.animation.reversed();
        this.animations.forEach(function (animation) {
          return animation.reverse();
        });
        e.currentTarget.animation.reversed(!selectedReversedState);
      } else {
        this.accordionInit();
        this.animations.forEach(function (animation) {
          return animation.reverse();
        });

        var _selectedReversedState = e.currentTarget.animation.reversed();

        e.currentTarget.animation.reversed(!_selectedReversedState);
      }
    } // Events
    // --------------------------------------------------

  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this6 = this;

      // global
      this.app.on('scroll', this.onScroll, this);
      this.onScroll(); // actions

      this.bounds.open = this.onOpen.bind(this);
      this.bounds.close = this.onClose.bind(this);
      this.bounds.toggleAccordion = this.onToggleAccordion.bind(this);
      this.$.btnOpen.on('click', this.bounds.open);
      this.$.btnClose.on('click', this.bounds.close);
      this.$.accordion.on('click', this.bounds.toggleAccordion); // Search

      this.bounds.searchOpen = this.onSearchOpen.bind(this);
      this.bounds.searchClose = this.onSearchClose.bind(this);
      this.$.searchOpen.on('click', this.bounds.searchOpen);
      this.$.searchClose.on('click', this.bounds.searchClose); // outside nav clicks

      this.bounds.outside = this.onOutsideClick.bind(this); // Made by Pan !

      this.$.pan.on('mouseenter', function (e) {
        if (typeof _this6.tl.pan !== 'undefined' && !_this6.tl.pan.isActive()) {
          _this6.tl.pan.play(0);
        }
      });
    }
  }, {
    key: "onScroll",
    value: function onScroll() {
      this.scroll = window.pageYOffset || document.documentElement.scrollTop;
      this.stickyNavBar();
    }
  }, {
    key: "onOpen",
    value: function onOpen(e) {
      if (e) e.preventDefault();
      this.open();
    }
  }, {
    key: "onClose",
    value: function onClose(e) {
      if (e) e.preventDefault();
      this.close();
    }
  }, {
    key: "onToggleAccordion",
    value: function onToggleAccordion(e) {
      this.toggleAccordion(e);
    }
  }, {
    key: "onOutsideClick",
    value: function onOutsideClick(e) {
      var target = e.target;

      if (target !== this.$.mobile[0] && !this.$.mobile[0].contains(target)) {
        e.preventDefault();
        this.close();
      }
    }
  }, {
    key: "onSearchOpen",
    value: function onSearchOpen(e) {
      if (e) e.preventDefault();
      this.searchOpen();
      this.$.searchInput[0].focus();
    }
  }, {
    key: "onSearchClose",
    value: function onSearchClose(e) {
      if (e) e.preventDefault();
      this.searchClose();
    }
  }]);

  return Navigation;
}(Controller);

export default Navigation;

if (module.hot) {
  module.hot.accept(function (err) {
    if (err) {
      console.error(err);
    }
  });
}